import { DeleteOutline } from "@mui/icons-material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import toast from "react-hot-toast";
import CancelIcon from "../../icons/cancel";
import SuccessIcon from "../../icons/success";
import { useTranslation } from "react-i18next";

const StyledModal = styled(Modal)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const PopupContainer = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F2F4F5",
    paddingTop: 0,
    paddingBottom: 29,
    paddingLeft: 78,
    paddingRight: 78,
    width: "745px",
    height: "341px",
    borderRadius: 0,
}));

const PopupContainer2 = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "#F2F4F5",
    width: "745px",
    height: "341px",
    [theme.breakpoints.up("sm")]: {
        width: "50%",
    },
    borderRadius: 0,
}));

const CloseButton = styled(IconButton)(({theme}) => ({
    color: theme.palette.grey[500],
    alignSelf: "flex-end",
    marginRight: -50
}));

const OkButton = styled(Button)(({theme}) => ({
    color: theme.palette.primary.main,
    width: "177px",
    height: "40px",
    "&.MuiButton-contained": {
        color: theme.palette.white.main,
    },
}));

export const SuccessAlert = ({open, onClose, message, subMessage, navigate}) => {
    return (
        <>
            <StyledModal open={open} onClose={onClose}>
                <PopupContainer>
                    <CloseButton onClick={onClose}>
                        <CancelIcon/>
                    </CloseButton>
                    <div style={{ width: '100%'}}>
                        <Typography
                            className={"popup-text"}
                            variant="h3">
                            {message}
                            {subMessage ? <br/> : <></>}
                            {subMessage ? subMessage : ''}
                        </Typography>
                    </div>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: (theme) => theme.spacing(2),
                        }}>
                        <SuccessIcon
                            style={{
                                color: (theme) => theme.palette.primary.main,
                                marginBottom: 20,
                                height: '90px !important',
                                width: '90px !important'
                            }}
                        />
                    </Box>
                    <OkButton style={{
                        marginTop: 21,
                        fontSize: 16,
                        fontFamily: 'Open Sans'
                    }} variant="contained" onClick={navigate}>
                        OK
                    </OkButton>
                </PopupContainer>
            </StyledModal>
        </>
    );
};

export const ErrorAlert = ({open, onClose, message}) => {
    return (
        <StyledModal open={open} onClose={onClose}>
            <PopupContainer>
                <CloseButton onClick={onClose}>
                    <CancelIcon/>
                </CloseButton>
                <Typography
                    variant="h3"
                    sx={{marginBottom: (theme) => theme.spacing(2)}}
                >
                    {message}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: (theme) => theme.spacing(2),
                    }}
                >
                    <ErrorOutlineIcon
                        sx={{
                            color: (theme) => theme.palette.error.main,
                            height: "50px",
                            width: "50px",
                            marginRight: (theme) => theme.spacing(2),
                        }}
                        fontSize="large"
                    />
                </Box>
                <OkButton variant="contained" onClick={onClose}>
                    OK
                </OkButton>
            </PopupContainer>
        </StyledModal>
    );
};

export const DeleteAlert = ({
                                open,
                                onClose,
                                message,
                                deleteClicked,
                                cancelClicked,
                                downloadClicked,
                            }) => {
    const {t} = useTranslation()
    // Custom toast style
    const customToastStyle = {
        background: "#4c8991",
        color: "white",
    };

    // Show custom toast
    const showCustomToast = () => {
        toast("Pdf download in progress", {
            style: customToastStyle,
        });
    };

    return (
        <StyledModal open={open} onClose={onClose}>
            <PopupContainer>
                <div style={{ width: '100%'}}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        marginTop: 49
                    }}>
                        <Typography className={"popup-text"} variant="h3">
                            {message}
                        </Typography>
                        <CloseButton onClick={onClose}>
                            <CancelIcon/>
                        </CloseButton>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            gap: '43px',
                        }}>
                        <Typography variant="body1" style={{ fontSize: "16px", fontWeight: 300, lineHeight: "22px"}}>
                            {t("You can save your data before deleting.")}
                        </Typography>
                        <Button
                            variant="outlined"
                            sx={{
                                color: (theme) => theme.palette.majorBlack,
                                border: "1px solid #353535",
                                fontSize: "16px", fontWeight: 300, lineHeight: "22px"
                            }}
                            startIcon={<FileDownloadOutlinedIcon/>}
                            onClick={() => {
                                downloadClicked();
                            }}>
                            {t("Download data")}
                        </Button>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                        }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: (theme) => theme.spacing(2),
                                width: "100%",
                                justifyContent: "center",
                            }}
                            onClick={deleteClicked}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "red",
                                    width: "209px",
                                    height: "40px",
                                    marginTop: "51px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "13px",
                                    borderRadius: "6px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        backgroundColor: "red",
                                        boxShadow: "none",
                                    },
                                    fontSize: "16px", fontWeight: 300, lineHeight: "22px"
                                }}>
                                <svg width="20" height="26" viewBox="0 0 20 26" fill="white" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.2015 9.19303L17.8015 21.3C17.7674 22.3369 17.3306 23.3197 16.5838 24.0398C15.837 24.76 14.8389 25.1607 13.8015 25.157H6.20149C5.16471 25.1607 4.16725 24.7606 3.42054 24.0413C2.67383 23.322 2.23658 22.3402 2.20149 21.304L1.80149 9.19303C1.79274 8.92781 1.8897 8.66998 2.07105 8.47626C2.2524 8.28253 2.50328 8.16878 2.76849 8.16003C3.03371 8.15128 3.29154 8.24824 3.48526 8.42959C3.67899 8.61094 3.79274 8.86181 3.80149 9.12703L4.20149 21.237C4.22141 21.754 4.44088 22.2431 4.81382 22.6017C5.18676 22.9603 5.68413 23.1604 6.20149 23.16H13.8015C14.3195 23.1604 14.8175 22.9597 15.1905 22.6003C15.5636 22.2409 15.7826 21.7507 15.8015 21.233L16.2015 9.12703C16.2102 8.86181 16.324 8.61094 16.5177 8.42959C16.7114 8.24824 16.9693 8.15128 17.2345 8.16003C17.4997 8.16878 17.7506 8.28253 17.9319 8.47626C18.1133 8.66998 18.2102 8.92781 18.2015 9.19303ZM19.5245 5.16403C19.5245 5.42925 19.4191 5.6836 19.2316 5.87114C19.0441 6.05867 18.7897 6.16403 18.5245 6.16403H1.47949C1.21428 6.16403 0.959921 6.05867 0.772385 5.87114C0.584849 5.6836 0.479492 5.42925 0.479492 5.16403C0.479492 4.89881 0.584849 4.64446 0.772385 4.45692C0.959921 4.26939 1.21428 4.16403 1.47949 4.16403H4.57949C4.89634 4.16488 5.20217 4.04782 5.43747 3.83563C5.67277 3.62343 5.82071 3.33128 5.85249 3.01603C5.92629 2.27652 6.27275 1.59096 6.82439 1.09294C7.37602 0.594916 8.09331 0.320098 8.83649 0.322032H11.1665C11.9097 0.320098 12.627 0.594916 13.1786 1.09294C13.7302 1.59096 14.0767 2.27652 14.1505 3.01603C14.1823 3.33128 14.3302 3.62343 14.5655 3.83563C14.8008 4.04782 15.1066 4.16488 15.4235 4.16403H18.5235C18.7887 4.16403 19.0431 4.26939 19.2306 4.45692C19.4181 4.64446 19.5235 4.89881 19.5235 5.16403H19.5245ZM7.58849 4.16403H12.4165C12.2851 3.86377 12.1991 3.54562 12.1615 3.22003C12.1367 2.97354 12.0213 2.74502 11.8377 2.57874C11.654 2.41247 11.4152 2.32028 11.1675 2.32003H8.83749C8.58976 2.32028 8.35093 2.41247 8.16729 2.57874C7.98365 2.74502 7.86827 2.97354 7.84349 3.22003C7.80552 3.54567 7.72024 3.86383 7.58849 4.16403ZM8.59549 19.315V10.8C8.59549 10.5348 8.49013 10.2805 8.3026 10.0929C8.11506 9.90539 7.86071 9.80003 7.59549 9.80003C7.33028 9.80003 7.07592 9.90539 6.88839 10.0929C6.70085 10.2805 6.59549 10.5348 6.59549 10.8V19.319C6.59549 19.5842 6.70085 19.8386 6.88839 20.0261C7.07592 20.2137 7.33028 20.319 7.59549 20.319C7.86071 20.319 8.11506 20.2137 8.3026 20.0261C8.49013 19.8386 8.59549 19.5842 8.59549 19.319V19.315ZM13.4095 19.315V10.8C13.4095 10.5348 13.3041 10.2805 13.1166 10.0929C12.9291 9.90539 12.6747 9.80003 12.4095 9.80003C12.1443 9.80003 11.8899 9.90539 11.7024 10.0929C11.5148 10.2805 11.4095 10.5348 11.4095 10.8V19.319C11.4095 19.5842 11.5148 19.8386 11.7024 20.0261C11.8899 20.2137 12.1443 20.319 12.4095 20.319C12.6747 20.319 12.9291 20.2137 13.1166 20.0261C13.3041 19.8386 13.4095 19.5842 13.4095 19.319V19.315Z"
                                        fill="white"/>
                                </svg>
                                {t("Delete")}
                            </Button>
                        </Box>
                        <p
                            onClick={cancelClicked}
                            style={{
                                cursor: 'pointer',
                                color: (theme) => theme.palette.majorBlack,
                                textDecoration: "underline",
                                marginTop: "16px",
                                marginBottom: "21px",
                                fontSize: "16px", fontWeight: 300, lineHeight: "22px"
                            }}>
                            <u>{t("Cancel")}</u>
                        </p>
                    </div>
                </div>
            </PopupContainer>
        </StyledModal>
    );
};
